<template>
  <div>
    <div class="form-group">
      <label for="txtExtension">Extension</label>
      <input type="text" class="form-control"  :class="{ 'is-invalid': is_extension_in_use }" id="txtExtension" v-model="extension" @input="$emit('input', extension)">
      <small class="form-text text-muted">{{ helper_text }}</small>
      <div class="invalid-feedback">That extension is in use</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    helper_text: {
      type: String,
      required: false
    },
    value: {}
  },
  data: function () {
    return {
      extension: this.value
    }
  },
  computed: {
    ...mapGetters({
      alerts: 'allAlerts',
      devices: 'allDevices',
      notifications: 'allNotifications',
      zones: 'allZones',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_alerts: function () {
      return this.alerts.filter(alert => alert.site_id === this.scoped_site_id &&
                                Number(alert.extension) !== 0 &&
                                Number(alert.extension) === Number(this.extension))
    },
    filtered_devices: function () {
      return this.devices.filter(device => device.site_id === this.scoped_site_id &&
                                Number(device.extension) !== 0 &&
                                Number(device.extension) === Number(this.extension))
    },
    filtered_notifications: function () {
      return this.notifications.filter(notification => notification.site_id === this.scoped_site_id &&
                                      Number(notification.extension !== 0) &&
                                      Number(notification.extension) === Number(this.extension))
    },
    filtered_zones: function () {
      return this.zones.filter(zone => zone.site_id === this.scoped_site_id &&
                              Number(zone.extension) !== 0 &&
                              Number(zone.extension) === Number(this.extension))
    },
    is_extension_in_use () {
      if (this.filtered_alerts.length === 0 && this.filtered_devices.length === 0 &&
          this.filtered_notifications.length === 0 && this.filtered_zones.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    value (newValue, oldValue) {
      this.extension = newValue
    }
  },
  created () {
    this.$store.dispatch('getAlerts')
    this.$store.dispatch('getDevices')
    this.$store.dispatch('getNotifications')
    this.$store.dispatch('getZones')
  }
}
</script>
